import React from 'react';

const Header = () => {
    return (
        <div className="header">
            <h4>FAQ about Uzbekistan</h4>
        </div>
    );
};

export default Header;